import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';

const open = keyframes`
  100% {
      transform: scale3d(1, 1, 1);
  }
`;

const close = keyframes`
  from {
    transform: scale3d(1, 1, 1);
  }
  to {
      transform: scale3d(0, 0, 0);
  }
`;


class AnimateCircle extends Component {
    render() {
        const {
            className,
            radius = '2400',
            isClosed,
            onAnimationEnd,
        } = this.props;

        return (
            <Root
                className={className}
                onAnimationEnd={onAnimationEnd}
            >
                <Circle isClosed={isClosed} width={radius} height={radius} />
            </Root>
        );
    }
}

const Root = styled.div`
    border-radius: 50%;

    position: fixed;

    background: transparent;

    display: flex;
    align-items: center;
    justify-content: center;
`;

const Circle = styled.div`
    width: ${({ width }) => width}px;
    height: ${({ height }) => height}px;
    border-radius: 50%;

    position: absolute;

    background: #0032A0;

    transform: scale3d(0, 0, 0);

    animation-name: ${({ isClosed }) => (!isClosed ? open : close)};
    animation-duration: ${({ isClosed }) => (!isClosed ? 1 : 0.8)}s;
    animation-timing-function: ease-out;
    animation-fill-mode: forwards;
`;

export default AnimateCircle;
